export default __webpack_public_path__ + "static/media/Body_C3.4d7cacc3.svg";